/** Kind of accrued time. */
export enum WorktimeImportAccrualKind {
  /** Register addition/subtraction  */
  Default = "default",
  /** Current saldo for the total accruing period. For example, start saldo for the holiday year. */
  Saldo = "saldo",
}

(()=>{ /* Snowpack Noop HACK for: https://github.com/snowpackjs/snowpack/issues/3585 */ })();